/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */



$( document ).ready(function() {

    console.log(location.hostname);
    if(location.hostname == "www.onartpro.com"){
      window.location = "https://indielee.com";
    }
	if($("a[href*='sample-']").closest(".ProductList .Grid__Cell").length>0) {
	  $("a[href*='sample-']").closest(".ProductList .Grid__Cell").css( "display", "none" );
	}
	if($("a[href*='samples-']").closest(".ProductList .Grid__Cell").length>0) {
	  $("a[href*='samples-']").closest(".ProductList .Grid__Cell").css( "display", "none" );
	}
	if($("a[href*='-samples']").closest(".ProductList .Grid__Cell").length>0) {
	  $("a[href*='-samples']").closest(".ProductList .Grid__Cell").css( "display", "none" );
	}
    if($("a[href*='-reward']").closest(".ProductList .Grid__Cell").length>0) {
	  $("a[href*='-reward']").closest(".ProductList .Grid__Cell").css( "display", "none" );
	}
    if($("a[href*='reward-']").closest(".ProductList .Grid__Cell").length>0) {
	  $("a[href*='reward-']").closest(".ProductList .Grid__Cell").css( "display", "none" );
	}
});
$( document ).ready(function() {
	if($("a[href*='sample-']").closest(".Carousel__Cell").length>0) {
	  $("a[href*='sample-']").closest(".Carousel__Cell").css( "display", "none" );
	}
	if($("a[href*='samples-']").closest(".Carousel__Cell").length>0) {
	  $("a[href*='samples-']").closest(".Carousel__Cell").css( "display", "none" );
	}
	if($("a[href*='-samples']").closest(".Carousel__Cell").length>0) {
	  $("a[href*='-samples']").closest(".Carousel__Cell").css( "display", "none" );
	}
    if($("a[href*='-reward']").closest(".Carousel__Cell").length>0) {
	  $("a[href*='-reward']").closest(".Carousel__Cell").css( "display", "none" );
	}
    if($("a[href*='reward-']").closest(".Carousel__Cell").length>0) {
	  $("a[href*='reward-']").closest(".Carousel__Cell").css( "display", "none" );
	}
});
$( ".ProductItem__ImageWrapper--withAlternateImage" ).live( "mouseenter", function() {
  $(this).closest(".ProductItem").toggleClass("white-bg")
});
$( ".ProductItem__ImageWrapper--withAlternateImage" ).live( "mouseleave", function() {
  $(this).closest(".ProductItem").toggleClass("white-bg")
});

$('#CartSamplesCancel').click(function(event) {
	$("button#samples_button").click(); 
});

$(document).ready(function() {
        $('#VideoClick').click(function() {
            $('#VideoClick').fadeOut('fast', function() {
                $(".VideoElement").css("display","block");
                $("video").click();
             });
        });
  		$('.Video__PlayButton').click(function() {
            $('#VideoClick').fadeOut('fast', function() {
                $(".VideoElement").css("display","block");
                $("video").click();
             });
        });
  	
});
$(document).ready(function() {
  		var anchorElement = $(".Product__Aside button[data-type='transcript']");
  		$('.VideoTranscript__HideShow').click(function(event) {
    	if (anchorElement.attr("aria-expanded") == "false") {
        	
    			$(".Product__Aside button[data-type='transcript']").click(); 
    		
    	} else {
        	
    	}
        });
});
$(document).ready(function(){
      setTimeout(function() {
        $('.yotpo-user-details-modal-input').attr('aria-label', 'User name');
        $('.productRitualIco"').attr('aria-label', 'Share Icon');
      }, 3000);
});
$(window).bind("load", function() {
      setTimeout(function() {
        $('.yotpo-user-details-modal-input').attr('aria-label', 'User name');
        $('.productRitualIco"').attr('aria-label', 'Share Icon');
      }, 3000);
});

$(document).ready(function() {
  $('.readmore').click(function (event) {
    $('.description_full').toggleClass('open');
    $('.description_excerpt').toggleClass('close');
  });
  $('.readmore-homepage').click(function (event) {
    $('.Centered_Text__Card-Expand-Link').toggleClass('close');
    $('.Centered_Text__Card-Expand-Text').toggleClass('open');
  });
});

$('.Quotes').flickity({
  // options
  contain: true,
  prevNextButtons: false,
  pageDots: true,
  freeScroll: false
});

;(function(d) {
  
  var gallery = d.getElementById('Quotes');
  if(gallery){
    var count = gallery.getElementsByClassName('Carousel_Cell').length;

    if (count > 1) {
      var flkty = new Flickity(gallery, {
        // flickity options
        contain: true,
        prevNextButtons: false,
        pageDots: true,
        freeScroll: false
      });
    }
  }

})(document);


$(document).ready(function(){
  $("#slider").bind("input change", (e)=>{
    const sliderPos = e.target.value;
    // Update the width of the foreground image
    $('.Before-After__Image-Foreground').css('width', `${sliderPos}%`)
    // Update the position of the slider button
    $('.Before-After__Image-Slider-Button').css('left', `calc(${sliderPos}%)`)
    if (sliderPos > 50) {
      $(".Before-After__Image-Label").text("Before");
    } else {
      $(".Before-After__Image-Label").text("After");
    }
  });
  var width = $(".Before-After__Image").width();
  var width = width + "px 100%";
  $(".Before-After__Image-Img").css("background-size", width);
  var height = $(".Before-After__Image-Wrapper").height();
  var height = height + "px";
  document.body.style.setProperty("--before-after-height", height);
});

$(window).bind('resize', function(){
  var width = $(".Before-After__Image").width();
  var width = width + "px 100%";
  $(".Before-After__Image-Img").css("background-size", width);
  var height = $(".Before-After__Image-Wrapper").height();
  var height = height + "px";
  document.body.style.setProperty("--before-after-height", height);
});



  
